import { takeLatest, put, select } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { downPaymentPath, downpaymentDetailPath, homePath } from 'routes'
import { getCompanies, getVendors, } from './options'

const FETCH_DOWNPAYMENT = makeKeys('FETCH_DOWNPAYMENT')
const GET_DOWNPAYMENT_DETAIL = makeKeys('GET_DOWNPAYMENT_DETAIL')
const GET_DOWNPAYMENT_APPROVER = makeKeys('GET_DOWNPAYMENT_APPROVER')
const APPROVER_DOWNPAYMENT_ACTION = makeKeys('APPROVER_DOWNPAYMENT_ACTION')
const GET_DP_GOA_WORK_FLOW_VIEW_MODE = makeKeys('GET_DP_GOA_WORK_FLOW_VIEW_MODE')
const SUBMIT_DP = 'SUBMIT_DP'
const RESUBMIT_DP = 'RESUBMIT_DP'
const CANCEL_DP = 'CANCEL_DP'
const SAVE_QUATATION_ATTACEMENT_DP = 'SAVE_QUATATION_ATTACEMENT_DP'
const UPDATE_DOWNPAYMENT = 'UPDATE_DOWNPAYMENT'
const SET_DOWNPAYMENT_ACTIONNAME = 'SET_DOWNPAYMENT_ACTIONNAME'
const INITIALIZE_DP = 'INITIALIZE_DP'
const SAVE_DP_ATTACHEMNTS = 'SAVE_DP_ATTACHEMNTS'
const SAVE_DP_ATTACHEMNTSIN = 'SAVE_DP_ATTACHEMNTSIN'
const GET_WORKFLOW_APPROVER = makeKeys('GET_DP_WORKFLOW_APPROVER')
const GET_WORKFLOW_APPROVER_VIEW = makeKeys('GET_DP_WORKFLOW_APPROVER_VIEW')

export const initializeDP = makeAction(INITIALIZE_DP)
export const fetchDownPayment = makeAction(FETCH_DOWNPAYMENT.REQUEST, 'dataSearch')
export const getDownPaymentDetail = makeAction(GET_DOWNPAYMENT_DETAIL.REQUEST, 'id')
export const getDownPaymentApprover = makeAction(GET_DOWNPAYMENT_APPROVER.REQUEST, 'id')
export const approverDownPaymentAction = makeAction(APPROVER_DOWNPAYMENT_ACTION.REQUEST, 'data', 'history', 'actionName')
export const submitDP = makeAction(SUBMIT_DP, 'data', 'history', 'actionName')
export const resubmitDP = makeAction(RESUBMIT_DP, 'data', 'history')
export const cancelDP = makeAction(CANCEL_DP, 'data', 'history')
export const saveDPAttachments = makeAction(SAVE_DP_ATTACHEMNTS, 'data', 'history', 'isSubmit', 'isResubmit')
export const saveDPAttachmentsInvoices = makeAction(SAVE_DP_ATTACHEMNTSIN, 'data', 'history', 'isSubmit', 'isResubmit')
export const saveQuatationAttachmentDP = makeAction(SAVE_QUATATION_ATTACEMENT_DP, 'data', 'history', 'isSubmit', 'isResubmit')
export const getGOAWorkFlowViewMode = makeAction(GET_DP_GOA_WORK_FLOW_VIEW_MODE.REQUEST, 'dpId')
export const getWorkflowApproverView = makeAction(GET_WORKFLOW_APPROVER_VIEW.REQUEST, 'dpId')
export const getWorkflowApprover = makeAction(GET_WORKFLOW_APPROVER.REQUEST, 'data')
export const updateDownPayment = makeAction(UPDATE_DOWNPAYMENT, 'data', 'history', 'actionName')
export const setDownpaymentActionName = makeAction(SET_DOWNPAYMENT_ACTIONNAME, 'actionName')


const fetchDownPaymentSuccess = makeAction(FETCH_DOWNPAYMENT.SUCCESS, 'data')
const getDownPaymentDetailSuccess = makeAction(GET_DOWNPAYMENT_DETAIL.SUCCESS, 'data')
const getDownPaymentApproverSuccess = makeAction(GET_DOWNPAYMENT_APPROVER.SUCCESS, 'data')
const getGOAWorkFlowViewModeSuccess = makeAction(GET_DP_GOA_WORK_FLOW_VIEW_MODE.SUCCESS, 'data')

const getDownPaymentApproverFailure = makeAction(APPROVER_DOWNPAYMENT_ACTION.FAILURE)
const getWorkflowApproverSuccess = makeAction(GET_WORKFLOW_APPROVER.SUCCESS, 'data')
const getWorkflowApproverFailure = makeAction(GET_WORKFLOW_APPROVER.FAILURE)


const DPApiPath = path => path ? `downPayments/${path}` : 'downPayments'
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* fetchDownPaymentRequest(action) {
  const { dataSearch } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(DPApiPath(), dataSearch)
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchDownPaymentSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchDownPayment(dataSearch))
    } else {
      yield put(fetchDownPaymentSuccess({}))
    }
  }
}

function* initializeDPRequest() {
  try {
    const state = yield select()
    if (!state.options.companies.data.length) {
      yield put(getCompanies())
    }
    if (!state.options.vendors.length) {
      yield put(getVendors())
    }
  } catch (e) {
    console.log(e)
  }
}

const a = [
  {
    id: 1,
    status: 0,
    documentNumber: 'DP100001001',
    prNumber: 'PR100011',
    rfqNumber: 'RFQ400920',
    poNumber: 'PO2003848',
    contractNumber: '0811111111',
    title: 'Test title',
    projectName: 'Test project',
    vendorName: 'Test vendor',
    companyName: 'Company NAme',
    requesterName: 'Requester Name',
    ownerName: 'Owner Name',
    slaStatus: '',
    slaRemaining: '',
    createDate: '',
    submittedDate: '',
    modifiedDate: ''
  },
  {
    id: 2,
    status: 0,
    documentNumber: 'DP100001002',
    prNumber: 'PR100012',
    rfqNumber: 'RFQ400921',
    poNumber: 'PO2003849',
    contractNumber: '0822222222',
    title: 'Test title',
    projectName: ' project',
    vendorName: 'vendor',
    companyName: 'Company ',
    requesterName: 'Requester ',
    ownerName: 'Owner ',
    slaStatus: '',
    slaRemaining: '',
    createDate: '',
    submittedDate: '',
    modifiedDate: ''
  }
]

function* getDownPaymentDetailRequest(action) {
  const { id } = action.payload
  try {
    yield put(appLoading('Loading DownPayment.'))
    const response = yield httpGet(DPApiPath(`${id}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {

        yield put(getDownPaymentDetailSuccess(response.data))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getDownPaymentDetail(id))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load Down Payment data error!'))
      }
    }
  }
}

function* getDownPaymentApproverRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(DPApiPath(`${id}/goaApproverViewMode`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getDownPaymentApproverSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getDownPaymentApprover(id))
    } else {
      yield put(getDownPaymentApproverFailure())
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load Down Payment approver error!'))
      }
    }
  }
}

function* saveDPAttachmentsRequest(action) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Upload attachments'))
    var attachmentsData = {}
    if (data.DP01) attachmentsData.DP01 = data.DP01
    if (data.DP02) attachmentsData.DP02 = data.DP02
    const response = yield httpPost(DPApiPath(`${data.id}/Attachments`), attachmentsData, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      if (isSubmit) {
        if (data.status == 5) { // status reject Resubmit
          yield put(resubmitDP(data, history))
        } else {
          yield put(submitDP(data, history))
        }
      } else {
        history.push(downPaymentPath)
        yield put(toastSuccess('Save DownPayment success.'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(toastError('Upload Attachments DownPayment fail.'))
    yield put(appLoaded())
  }
}

function* saveDPAttachmentsInvoicesRequest(action) {
  const { data, history, isSubmit } = action.payload
  try {
    yield put(appLoading('Upload attachments'))
    var attachmentsData = {}
    if (data.DP01) attachmentsData.DP01 = data.DP01
    const response = yield httpPost(DPApiPath(`${data.id}/attachmentInvoices`), attachmentsData, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      if (isSubmit) {
        if (data.status == 2) { // status reject Resubmit
          yield put(resubmitDP(data, history))
        } else {
          yield put(submitDP(data, history))
        }
      } else {
        history.push(downPaymentPath)
        yield put(toastSuccess('Save DownPayment success.'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(toastError('Upload Attachments DownPayment fail.'))
    yield put(appLoaded())
  }
}

function* submitDPRequest(action) {
  const { data, history } = action.payload
  // console.log(data)
  try {
    yield put(appLoading('Submit DP'))
    const response = yield httpPost(DPApiPath(`${data.id}/submit`))
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Submit Down Payment success.'))
      history.push(downPaymentPath)
      yield put(appLoaded())
    }
  } catch (e) {
    // yield put(toastError('Submit Down Payment fail.'))
    yield put(appLoaded())
  }
}

function* resubmitDPRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading(''))
    const response = yield httpPost(DPApiPath(`reSubmit`), { docId: data.id, sn: data.sn, comment: '' })
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Submit Down Payment success.'))
      history.push(downPaymentPath)
      yield put(appLoaded())

    }
  } catch (e) {
    // yield put(toastError('Submit Down Payment fail.'))
    yield put(appLoaded())
  }
}

function* cancelDPRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(`DPApiPath/${data.id}/cancel`, { sn: data.sn, comment: data.actionComment })
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Cancel Down Payment success.'))
      yield put(appLoaded())
      history.push(downPaymentPath)

    }
  } catch (e) {
    yield put(toastError('Cancel Down Payment fail.'))
    yield put(appLoaded())
  }
}

function* getGOAWorkFlowViewModeRequest(action) {
  const { dpId } = action.payload
  try {
    const response = yield httpGet(DPApiPath(`${dpId}/goaApproverViewMode`))
    if (response.status >= 200 && response.status < 300) {
      yield put(getGOAWorkFlowViewModeSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getGOAWorkFlowViewMode(dpId))
    } else {
      yield put(getGOAWorkFlowViewModeSuccess([]))
    }
  }
}

function* getWorkflowApproverRequest(action) {
  const { data } = action.payload
  const { createdByUser, requesterUser, companyCode, items, goaItemCode, isAsset, isIt, totalAmount,
    goaId, specialApprovalId, rentDays } = data

  const purchasingGroup = (items && items.length) ? items[0].purchasingGroup : null
  const currency = (items && items.length) ? items[0].currency : null

  try {
    let itemDel = items ? items.filter(x => x.deleted === true) : []
    if (items && items.length && (itemDel.length !== items.length)) {
      const response = yield httpGet(DPApiPath(`workflowApprover`), {
        creater: createdByUser,
        requester: requesterUser,
        companycode: companyCode,
        purchGroup: purchasingGroup,
        goaItemCode,
        currency,
        isAsset,
        isIT: isIt,
        amount: totalAmount,
        goaId,
        specialApprovalId,
        days: rentDays,
      })
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getWorkflowApproverSuccess(response.data))
        }
      }
    } else {
      yield put(getWorkflowApproverFailure())
    }
  } catch (e) {
    yield put(toastError('Get workflow approver error'))
    yield put(getWorkflowApproverFailure())
  }
}

function* updateDownPaymentRequest(action) {
  const { data, history, actionName } = action.payload
  // console.log(data)
  try {
    yield put(appLoading(''))
    const response = yield httpPut(DPApiPath(`${data.id}`), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(submitDP(data, history, actionName))
      // yield put(appLoaded())
      // yield put(toastSuccess('Submit Down Payment success.'))
      // history.push(downPaymentPath)
    }
  } catch (e) {
    yield put(toastSuccess('Submit Down Payment success.'))
    yield put(appLoaded())
  }
}

function* approverDownPaymentActionRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(DPApiPath(`${data.docId}/actionWorkflow`), {
      docId: data.docId,
      sn: data.sn,
      action: data.action,
      comment: data.comment,
      commentAttachments: data.commentAttachments,
      dp02: data.attachmentsInterims,
      dp01: data.attachmentInvoices,
    }, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Action Down Payment success.'))
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(downPaymentPath)
      }
      yield put(appLoaded())
    }
  } catch (e) {
    yield put(toastError('Action Down Payment fail.'))
    yield put(appLoaded())
  }
}

export function* watchDownPaymentSaga() {
  yield takeLatest(FETCH_DOWNPAYMENT.REQUEST, fetchDownPaymentRequest)
  yield takeLatest(INITIALIZE_DP, initializeDPRequest)
  yield takeLatest(GET_DOWNPAYMENT_DETAIL.REQUEST, getDownPaymentDetailRequest)
  yield takeLatest(GET_DOWNPAYMENT_APPROVER.REQUEST, getDownPaymentApproverRequest)
  yield takeLatest(UPDATE_DOWNPAYMENT, updateDownPaymentRequest)
  yield takeLatest(SUBMIT_DP, submitDPRequest)
  yield takeLatest(RESUBMIT_DP, resubmitDPRequest)
  yield takeLatest(CANCEL_DP, cancelDPRequest)
  yield takeLatest(GET_DP_GOA_WORK_FLOW_VIEW_MODE.REQUEST, getGOAWorkFlowViewModeRequest)
  yield takeLatest(GET_WORKFLOW_APPROVER.REQUEST, getWorkflowApproverRequest)
  yield takeLatest(APPROVER_DOWNPAYMENT_ACTION.REQUEST, approverDownPaymentActionRequest)
  yield takeLatest(SAVE_DP_ATTACHEMNTS, saveDPAttachmentsRequest)
  yield takeLatest(SAVE_DP_ATTACHEMNTSIN, saveDPAttachmentsInvoicesRequest)
}

const initial = {
  listDownPayments: { data: {}, loading: false },
  downPaymentDetail: { data: {}, loading: false },
  approvers: { data: [], loading: false },
  dpActionName: ''
}

export default createReducer(initial, state => ({
  [FETCH_DOWNPAYMENT.REQUEST]: () => ({
    ...state,
  }),
  [FETCH_DOWNPAYMENT.SUCCESS]: (data) => ({
    ...state,
    listDownPayments: { data: data.data, loading: false }
  }),
  [FETCH_DOWNPAYMENT.FAILURE]: () => ({
    ...state,
    listDownPayments: { data: [], loading: false }
  }),
  [GET_DOWNPAYMENT_DETAIL.REQUEST]: () => ({
    ...state,
    downPaymentDetail: { data: {}, loading: true }
  }),
  [GET_DOWNPAYMENT_DETAIL.SUCCESS]: (data) => ({
    ...state,
    downPaymentDetail: { data: data.data, loading: false }
  }),
  [GET_DOWNPAYMENT_APPROVER.REQUEST]: () => ({
    ...state,
    approvers: { data: [], loading: true }
  }),
  [GET_DOWNPAYMENT_APPROVER.SUCCESS]: (data) => ({
    ...state,
    approvers: { data: data.data, loading: false }
  }),
  [GET_DOWNPAYMENT_APPROVER.FAILURE]: () => ({
    ...state,
    approvers: { data: [], loading: false }
  }),
  [GET_DP_GOA_WORK_FLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    goaWorkFlow: { data: [], loading: true }
  }),
  [GET_DP_GOA_WORK_FLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    goaWorkFlow: { data: data.data, loading: false }
  }),
  [GET_WORKFLOW_APPROVER_VIEW.REQUEST]: () => ({
    ...state,
    approverLoading: true
  }),
  [GET_WORKFLOW_APPROVER_VIEW.SUCCESS]: (data) => ({
    ...state,
    approvers: data.data,
    approverLoading: false
  }),
  [GET_WORKFLOW_APPROVER_VIEW.FAILURE]: (data) => ({
    ...state,
    approvers: [],
    approverLoading: false
  }),
  [SET_DOWNPAYMENT_ACTIONNAME]: (data) => ({
    ...state,
    dpActionName: data.actionName
  }),
}))
